import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { computed, defineComponent, reactive, toRefs } from "vue"; // modules

import AuthModule from "@/store/modules/auth";
import ModalModule from "@/store/modules/modal"; // components

import { NavbarAvatar } from "@/components/index"; // interfaces

import { ModalStatus } from "@/constants/modal"; // helpers

import { redirectToLoginPage } from "@/utils/helpers/router.helper"; //services

import { dexieDB } from "@/services/dexie-database";
import dayjs from "dayjs";
import CashFloatModule from "@/store/modules/cash-float";
import { openTopUpForm, confirmLogout, hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import AppModule from "@/store/modules/app";
import DeviceModule from "@/store/modules/device";
import CommonModule from "@/store/modules/common";
import { closeCustomerDisplay, hasCustomerDisplay, openCustomerDisplay } from "@/utils/vue-helpers/customer-display";
export default defineComponent({
  name: "NavbarMainMenu",
  components: {
    NavbarAvatar: NavbarAvatar
  },
  setup: function setup() {
    var state = reactive({
      onLogOut: function () {
        var _onLogOut = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!CashFloatModule.cashFloat) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 3;
                  return confirmLogout();

                case 3:
                  return _context.abrupt("return");

                case 4:
                  AuthModule.UserLogOut(); // remove gId parameter if it is set

                  if (AppModule.gid) {
                    AppModule.removeGID();
                  }

                  redirectToLoginPage();

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onLogOut() {
          return _onLogOut.apply(this, arguments);
        }

        return onLogOut;
      }(),
      toggleModalVisible: function toggleModalVisible(item) {
        ModalModule.setStatus(item);
      },
      dataBackupHandler: function () {
        var _dataBackupHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var tables, data, _iterator, _step, table, a, file, filename;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  tables = dexieDB.tables;
                  data = {};
                  _iterator = _createForOfIteratorHelper(tables);
                  _context2.prev = 3;

                  _iterator.s();

                case 5:
                  if ((_step = _iterator.n()).done) {
                    _context2.next = 12;
                    break;
                  }

                  table = _step.value;
                  _context2.next = 9;
                  return table.toArray();

                case 9:
                  data[table.name] = _context2.sent;

                case 10:
                  _context2.next = 5;
                  break;

                case 12:
                  _context2.next = 17;
                  break;

                case 14:
                  _context2.prev = 14;
                  _context2.t0 = _context2["catch"](3);

                  _iterator.e(_context2.t0);

                case 17:
                  _context2.prev = 17;

                  _iterator.f();

                  return _context2.finish(17);

                case 20:
                  //downloading the file
                  a = document.createElement("a");
                  file = new Blob([JSON.stringify(data)], {
                    type: "application/json"
                  });
                  filename = "smeetz-pos-".concat(dayjs().format("DD-MM-YYYY_HH-mm-ss"), ".json");
                  a.href = URL.createObjectURL(file);
                  a.download = filename;
                  a.click();

                case 26:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[3, 14, 17, 20]]);
        }));

        function dataBackupHandler() {
          return _dataBackupHandler.apply(this, arguments);
        }

        return dataBackupHandler;
      }(),
      startSales: function () {
        var _startSales = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return openTopUpForm();

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function startSales() {
          return _startSales.apply(this, arguments);
        }

        return startSales;
      }()
    });
    var isCustomerDisplayOpened = computed(function () {
      return CommonModule.isCustomerDisplayOpened;
    }); // Lets write a computed property that returns true only in TEST environment

    var isTEST = computed(function () {
      var env = process.env.VUE_APP_ENV;

      if (env === "test" || env === "TEST") {
        return true;
      }

      return false;
    });
    var hasLocation = computed(function () {
      // If there is no hardware location (machine not linked to a location or user using a browser) we don't show device settings
      if (DeviceModule.hardwareLocation) {
        return true;
      } else {
        return false;
      }
    });
    return _objectSpread(_objectSpread({
      ModalStatus: ModalStatus
    }, toRefs(state)), {}, {
      hasSalesStarted: hasSalesStarted,
      hasLocation: hasLocation,
      CashFloatModule: CashFloatModule,
      DeviceModule: DeviceModule,
      openCustomerDisplay: openCustomerDisplay,
      hasCustomerDisplay: hasCustomerDisplay,
      closeCustomerDisplay: closeCustomerDisplay,
      isCustomerDisplayOpened: isCustomerDisplayOpened,
      isTEST: isTEST
    });
  }
});